// src/store/mutations.js
export default {
  setLocationInterval(state, interval) {
    state.locationInterval = interval;
  }
};


// WEBPACK FOOTER //
// ./src/store/mutations.js